import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Meta } from "@angular/platform-browser";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {
  id: string;
  constructor(private activated: ActivatedRoute, private meta: Meta) {
    this.meta.addTags([
      {
        name: "description",
        content:
          "ARTkart - karting club, karting events organiser, retailer of kart parts"
      },
      { name: "author", content: "ARTkart.lt" },
      {
        name: "keywords",
        content:
          "ARTkart, artkart, ARTkart services, ARTkart karting club, karting, karts, Parolin, DD2, KZ2, Vega, Motorsport"
      }
    ]);
  }
  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts